import React from "react";
import { Instagram, Facebook, ImageOff } from "lucide-react";
import { resolveImg } from "@/lib/api";
import { mediaUrl } from "./mkMedia";

export const PostPreview = ({ form }) => {
  const tags = (form.hashtagsText || "").split(/\s+/).filter(Boolean).map((t) => (t.startsWith("#") ? t : `#${t}`)).join(" ");
  return (
    <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden shadow-sm" data-testid="post-preview">
      <div className="flex items-center gap-2 px-3 py-2.5 border-b border-slate-100">
        <div className="h-8 w-8 rounded-full bg-blue-900 text-white text-[10px] font-extrabold flex items-center justify-center">PTG</div>
        <div className="text-sm font-bold text-slate-900">prasadtutorgroup</div>
        <div className="ml-auto flex gap-1.5 text-slate-400">
          {form.platforms.includes("instagram") && <Instagram className="h-4 w-4 text-pink-600" />}
          {form.platforms.includes("facebook") && <Facebook className="h-4 w-4 text-blue-700" />}
        </div>
      </div>
      {form.format?.startsWith("reel") ? (
        <div className="aspect-[9/16] max-h-[520px] mx-auto bg-slate-900 flex items-center justify-center">
          {form.reel?.video_path ? <video key={form.reel.video_path} src={mediaUrl(form.reel.video_path)} controls playsInline className="h-full w-full object-contain" data-testid="post-preview-video" />
            : <div className="text-center text-slate-400 text-xs px-6"><ImageOff className="h-8 w-8 mx-auto mb-1" />Make the Reel preview to watch the final video here</div>}
        </div>
      ) : (
      <div className="aspect-square bg-slate-50 flex items-center justify-center">
        {form.image_path ? <img src={resolveImg(form.image_path)} alt="Poster" className="h-full w-full object-cover" data-testid="post-preview-image" />
          : <div className="text-center text-slate-400 text-xs"><ImageOff className="h-8 w-8 mx-auto mb-1" />No poster yet</div>}
      </div>
      )}
      <div className="p-3 text-sm text-slate-800 whitespace-pre-wrap max-h-64 overflow-y-auto" data-testid="post-preview-caption">
        {form.caption || <span className="text-slate-400">Caption will appear here…</span>}
        {form.include_enquiry_link && <div className="mt-2 text-blue-700">Admission enquiry: …/?src=instagram</div>}
        {tags && <div className="mt-2 text-blue-800">{tags}</div>}
      </div>
    </div>
  );
};
